import { toast } from 'react-toastify';
import { addCategory, AddCategoryFormValue } from './addCategory';

export const addCategoryDtoInitialValues: AddCategoryFormValue = {
  name: '',
};

export const useAddCategoryData = () => {
  const initialValues = addCategoryDtoInitialValues;

  async function submitAddCategory(values: AddCategoryFormValue) {
    const res = await addCategory(values);
    if (res.type === 'success') {
      toast.success('Successfully added category');
      return res.data;
    }
    toast.error(res.error.message);

    return null;
  }

  return { submitAddCategory, initialValues };
};
